import { Array, Result } from 'effect'

// 失敗はその列を作らないことを表す (Array.filterMap で落とす)
const toColumnNode = <T>(node: T | undefined): Result.Result<T, void> =>
  node === undefined ? Result.failVoid : Result.succeed(node)

/**
 * ピボットの行の列が属するノードを探す。
 * 集計値でソートするとき nodes[rowIndex] が空になるため、先頭のノードで代用する。
 */
export const findPivotRowColumnNode = <T>(nodes: readonly T[], rowIndex: number): Result.Result<T, void> =>
  toColumnNode(nodes[rowIndex] ?? nodes[0])

/**
 * ピボットの値の列が属するノード (末端のノード) を探す
 */
export const findPivotValueColumnNode = <T>(nodes: readonly T[]): Result.Result<T, void> => toColumnNode(nodes.at(-1))

interface ColumnKeyLike {
  value: string
  label?: string
}

const isEquivalentColumnKeys = Array.makeEquivalence<ColumnKeyLike>(
  (a, b) => a.value === b.value && a.label === b.label,
)

/**
 * 隣の列と末尾以外のキーが同じなら同じブロックに属する (ブロックの境目にだけ右罫線を引く)
 */
export const isNextColumnInSameBlock = (
  columnKey: readonly ColumnKeyLike[],
  nextColumnKey: readonly ColumnKeyLike[] | undefined,
): boolean => nextColumnKey !== undefined && isEquivalentColumnKeys(columnKey.slice(0, -1), nextColumnKey.slice(0, -1))
